import { ParameterType } from '@/study-search/enums';

import { Filter } from '../../Filter';
import { IIndexation } from '../../../../interfaces';
import { FilterKey } from '@studyportals/search-filters';

export class CountryFilter extends Filter implements IIndexation {
	public constructor() {
		super(FilterKey.COUNTRY, ParameterType.COUNTRY, []);
	}

	public canBeIndexed(): boolean {
		return this.values.length === 1;
	}
}
